module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOZJREFUOE9jZKAQMML0W8/948nEyDiTgeG/LAEzfzAwMKyR4GFOWB3G+BdugO28v48YmJgiDycwHgUZYDf3T/R/JgbPw4ksMSC+7fw/Sxj/MWz//ZF5HbPA361M/xkmHEpm2YRkwJ//h5NY4HxcBhxKZllqO+9vNwMjw93DicwzaG8AAwPDFmiY+IC8QLQLbOb/iWL8xzCNgZHxGdiA//+l/jMxZB1JZFlGlBcc5v+X+Pv/X+a330x9IP1cbP+KmRmYph1IZHxBlAH4onLUAAYGHGGAmpRxBaJl339OrEmZ4sxEbq4GAPb4wBErzwzbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_icon_operation.png
// module id = DVg5
// module chunks = 1